import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Firmar } from '../models/firmar';

const MAT_API = environment.apiUrl + '/matricular/';
const VALIDAR_API = environment.apiUrl;
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class MatriculacionService {

  constructor(protected http: HttpClient) { }

  postMatricula(formObj: any): Observable<any> {
    return this.http.post(VALIDAR_API + '/validar', formObj);
  }

  continuarTramite(formObj: any): Observable<any> {
    return this.http.post(VALIDAR_API + '/continuar', formObj);
  }

  iniciarFirma(firmar: Firmar): Observable<any> {
    return this.http.post<any>(MAT_API + 'iniciar', firmar);
  }

  reintentarFirma(firmar: any): Observable<any> {
    return this.http.post<any>(MAT_API + 'reintentarFirma', firmar);
  }

  infoQr(hash:string): Observable<any> {
    var body:any={};
    body.hash=hash;
    return this.http.post<any>(VALIDAR_API + `/proceso/validar`,body);
  }

  getMetricas():Observable<any>{
    return this.http.get<any>(VALIDAR_API+'/metricas').pipe(
      retry(1)
    );
  }

  anularCertificado(form:any){
    return this.http.post(VALIDAR_API + '/anular', form);
  }
}
